import React from 'react';
import classNames from 'classnames';

import styles from './Col.module.scss';

interface ColPropsI {
  children: React.ReactNode;
  className?: string;
  margin?: string;
  padding?: string;
  align?: string;
  justify?: string;
  width?: string;
  height?: string;
  scrollable?: boolean;
}

const Col: React.FC<ColPropsI> = (props: ColPropsI) => {
  const colClasses = classNames(styles.Col, {
    [`${props.className}`]: props.className,
    [styles.Col_scrollable]: props.scrollable
  });

  const style = {
    margin: props.margin ? props.margin : '0px',
    alignItems: props.align ? props.align : 'flex-start',
    justifyContent: props.justify ? props.justify : 'flex-start',
    width: props.width ? props.width : '100%',
    height: props.height ? props.height : '100%',
    padding: props.padding ? props.padding : '0px'
  };

  return (
    <div className={colClasses} style={style}>
      {props.children}
    </div>
  );
};

export default Col;
